import { useCallback, useMemo, useState } from 'react'

import { paywallCopy } from '../billing/paywallCopy'
import { useAuth } from '../auth/AuthProvider'
import { isDemoUiEnabled } from '../dev/demoMode'
import { PaywallModal } from '../components/billing/PaywallModal'

export const useOrganizationAccess = () => {
  const { organizations, session } = useAuth()
  const [ownerPaywallOpen, setOwnerPaywallOpen] = useState(false)

  const organization = useMemo(
    () =>
      session?.organizationId != null
        ? organizations.find((item) => item.id === session.organizationId)
        : undefined,
    [organizations, session?.organizationId],
  )

  const isOwner = isDemoUiEnabled || organization?.member_role === 'owner'

  const requestOwnerAccess = useCallback((): boolean => {
    if (isOwner) {
      return true
    }
    setOwnerPaywallOpen(true)
    return false
  }, [isOwner])

  const ownerPaywallModal = (
    <PaywallModal
      open={ownerPaywallOpen}
      title="Только для владельца"
      message={paywallCopy.ownerOnly}
      showUpgradeAction={false}
      onDismiss={() => setOwnerPaywallOpen(false)}
    />
  )

  return {
    organization,
    isOwner,
    canEditOrganization: organization?.can_edit ?? false,
    memberPermissions: organization?.member_permissions ?? [],
    jobTitle: organization?.job_title ?? null,
    requestOwnerAccess,
    ownerPaywallModal,
  }
}
